import { render, staticRenderFns } from "./ResourceDescriptionPreview.vue?vue&type=template&id=4532daab&scoped=true&"
import script from "./ResourceDescriptionPreview.vue?vue&type=script&lang=ts&"
export * from "./ResourceDescriptionPreview.vue?vue&type=script&lang=ts&"
import style0 from "./ResourceDescriptionPreview.vue?vue&type=style&index=0&id=4532daab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4532daab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4532daab')) {
      api.createRecord('4532daab', component.options)
    } else {
      api.reload('4532daab', component.options)
    }
    module.hot.accept("./ResourceDescriptionPreview.vue?vue&type=template&id=4532daab&scoped=true&", function () {
      api.rerender('4532daab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/resource-details/ResourceDescriptionPreview.vue"
export default component.exports